import {useState} from 'react';
import {useMutation} from '@apollo/client';
import {useForm} from 'react-hook-form';
import {Redirect} from 'react-router-dom';
import Button from '@core/ui/Button/LegacyButton';
import {Card, CardHeader} from '@core/ui/Content';
import {FORM_ERRORS, Form, FormFooter, Submit} from '@core/ui/FormElements';
import ResponsiveContent from '@core/ui/ResponsiveContent';
import DELETE_CONVERSION_URL_MUTATION from '@analytics/graphql-api/_old_mutations/DeleteConversionUrl';
import ORGANIZATION_KEY_QUERY from '@analytics/graphql-api/_old_queries/OrganizationKeyQuery';
import {ManagePixelsPixelUrlRouteProps} from '.';

export function PixelDeleteUrl({
  backPath,
  pixel,
  match: {
    params: {id},
  },
}: ManagePixelsPixelUrlRouteProps & {
  match: {params: {id: string}};
}) {
  const [loading, setLoading] = useState<boolean>(false);
  const [complete, setCompleted] = useState<boolean>(false);
  const {
    handleSubmit,
    formState: {errors},
    clearErrors,
    setError,
  } = useForm();

  const [deleteConversionUrl] = useMutation(DELETE_CONVERSION_URL_MUTATION, {
    refetchQueries: [ORGANIZATION_KEY_QUERY],
    awaitRefetchQueries: true,
  });

  const conversionUrl = pixel.conversionUrls.find((c) => c.id === id);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const data = await deleteConversionUrl({
        variables: {
          input: {
            conversionUrlId: conversionUrl.id,
          },
        },
      });
      if (data) {
        setCompleted(true);
      }
    } catch (e) {
      setError('graphql', FORM_ERRORS.network);
    }
    setLoading(false);
  };

  const onCancel = () => {
    clearErrors();
    setCompleted(true);
  };

  if ((!conversionUrl || complete) && !errors.graphql) {
    return <Redirect to={backPath} />;
  }

  return (
    <ResponsiveContent containerSize='small'>
      <CardHeader backPath={backPath}>Delete Conversion URL</CardHeader>
      <Card>
        <Form errors={errors} onSubmit={handleSubmit(onSubmit)}>
          <p>Are you sure you would like to delete "{conversionUrl?.url}"?</p>
          <FormFooter>
            <Button type='button' onClick={onCancel} disabled={loading}>
              Cancel
            </Button>
            <Submit loading={loading} disabled={loading} color='error'>
              Delete Conversion URL
            </Submit>
          </FormFooter>
        </Form>
      </Card>
    </ResponsiveContent>
  );
}
